module.exports = __webpack_public_path__ + "static/artboardng2-0200e74338d99a2c105459d77ba1e982.png";